import React from 'react';
import { FormControl, InputLabel, MenuItem, Select } from '@mui/material';

export type AssetMarketplaceFilterValue = 'all' | 'listed' | 'not_listed';

interface AssetMarketplaceFilterProps {
  value: AssetMarketplaceFilterValue;
  onChange: (value: AssetMarketplaceFilterValue) => void;
}

const AssetMarketplaceFilter: React.FC<AssetMarketplaceFilterProps> = ({ value, onChange }) => (
  <FormControl size="small" sx={{ minWidth: 180 }}>
    <InputLabel id="asset-marketplace-filter-label" sx={{ fontSize: '0.875rem' }}>
      Marketplace
    </InputLabel>
    <Select
      labelId="asset-marketplace-filter-label"
      label="Marketplace"
      value={value}
      onChange={e => onChange(e.target.value as AssetMarketplaceFilterValue)}
      sx={{
        fontSize: '0.875rem',
        '& .MuiSelect-select': { fontSize: '0.875rem' },
      }}
      MenuProps={{
        PaperProps: {
          sx: { '& .MuiMenuItem-root': { fontSize: '0.875rem' } },
        },
      }}
    >
      <MenuItem value="all">All</MenuItem>
      <MenuItem value="listed">Listed</MenuItem>
      <MenuItem value="not_listed">Not listed</MenuItem>
    </Select>
  </FormControl>
);

export default AssetMarketplaceFilter;
